import { createAction } from 'lib/store-utils';
import { OpenModalPayload } from './types';

export const BOX_CONFIRMATION_OPEN_MODAL = createAction<OpenModalPayload>('Confirmation / open modal');
export const BOX_CONFIRMATION_CLOSE_MODAL = createAction('Confirmation / close modal');
export const BOX_CONFIRMATION_CONFIRM_MODAL_REQUEST = createAction('Confirmation / confirm modal request');
export const BOX_CONFIRMATION_CONFIRM_MODAL_SUCCESS = createAction('Confirmation / confirm modal success');
